module.exports = __webpack_public_path__ + "static/img/user_photo_icon.5a9d247a.png";